import { render, staticRenderFns } from "./OsQuestionnairesForm.vue?vue&type=template&id=3f92d4a3&scoped=true"
import script from "./OsQuestionnairesForm.vue?vue&type=script&lang=ts"
export * from "./OsQuestionnairesForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f92d4a3",
  null
  
)

export default component.exports